import { createParentComponent } from "@/common/vueUtils";

export const DynamicGrid = createParentComponent<{ minWidth?: number }>(({ minWidth, children }) => {
  return (
    <div class="ga-dynamic-grid mb-4" style={`--ga-dynamic-grid--min-width: ${minWidth ?? 25}rem;`}>
      {children}
    </div>
  );
});
